import { lazy } from 'react';

// project imports
import Loadable from 'components/Loadable';
import ActivateAccount from 'sections/auth/ActivateAccount';

// jwt auth
const LoginPage = Loadable(lazy(() => import('pages/auth/Login')));
const RegisterPage = Loadable(lazy(() => import('pages/auth/Register')));

// ==============================|| AUTH ROUTING ||============================== //

const LoginRoutes = {
  path: '/',
  children: [
    {
      path: '/',
      children: [
        {
          path: '/login',
          element: <LoginPage />
        },
        {
          path: '/register',
          element: <RegisterPage />
        },
        {
          path: '/activate-account',
          element: <ActivateAccount />
        }

      ]
    }
  ]
};

export default LoginRoutes;
